"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ethersContext = void 0;
const viem = __importStar(require("viem"));
const _unitNames = ['wei', 'kwei', 'mwei', 'gwei', 'szabo', 'finney', 'ether'];
// Ethers.js compatible context functions. Consider deprecating.
exports.ethersContext = {
    AddressZero: viem.zeroAddress,
    HashZero: viem.zeroHash,
    MaxUint256: viem.maxUint256,
    defaultAbiCoder: {
        encode: (a, v) => {
            return viem.encodeAbiParameters(a.map((arg) => ({ type: arg })), v);
        },
        decode: (a, v) => {
            return viem.decodeAbiParameters(a.map((arg) => ({ type: arg })), v);
        },
    },
    zeroPad: (a, s) => viem.padHex(a, { size: s }),
    hexZeroPad: (a, s) => viem.padHex(a, { size: s }),
    hexlify: viem.toHex,
    stripZeros: viem.trim,
    formatBytes32String: (v) => viem.stringToHex(v, { size: 32 }),
    parseBytes32String: (v) => viem.hexToString(v, { size: 32 }),
    id: (v) => (v.startsWith('function ') ? viem.toFunctionSelector(v) : viem.keccak256(viem.toHex(v))),
    formatEther: viem.formatEther,
    formatUnits: (s, units) => {
        if (typeof units === 'string') {
            const index = _unitNames.indexOf(units);
            if (index < 0) {
                throw new Error(`formatUnits: unknown ethereum unit name: ${units}`);
            }
            units = 3 * index;
        }
        return viem.formatUnits(s, units);
    },
    parseEther: viem.parseEther,
    parseUnits: (s, units) => {
        if (typeof units === 'string') {
            const index = _unitNames.indexOf(units);
            if (index < 0) {
                throw new Error(`parseUnits: unknown ethereum unit name: ${units}`);
            }
            units = 3 * index;
        }
        return viem.parseUnits(s, units);
    },
    keccak256: viem.keccak256,
    sha256: viem.sha256,
    ripemd160: viem.ripemd160,
    solidityPack: viem.encodePacked,
    solidityKeccak256: (a, v) => viem.keccak256(viem.encodePacked(a, v)),
    soliditySha256: (a, v) => viem.sha256(viem.encodePacked(a, v)),
    serializeTransaction: viem.serializeTransaction,
    parseTransaction: viem.parseTransaction,
    encodeFunctionData: viem.encodeFunctionData,
    decodeFunctionData: viem.decodeFunctionData,
    encodeFunctionResult: viem.encodeFunctionResult,
    decodeFunctionResult: viem.decodeFunctionResult,
};
//# sourceMappingURL=ethers-context.js.map